module.exports = __webpack_public_path__ + "static/media/32-15.f8d13a2b.mp3";